import { Link } from "@/components/Elements";
import { RegisterForm } from "../components";
import { RegisterLayout } from "../components";
import { RouteConstant } from "@/routes/routeConstant";

export const Register = () => {
  return (
    <RegisterLayout title="Create an account">
      <RegisterForm />
      <div className="flex justify-center mt-[5px] items-center italic text-[14px]">
        Already have an account?&nbsp;
        <Link to={RouteConstant.Login}>Sign in</Link>
      </div>
    </RegisterLayout>
  );
};
